// extracted by mini-css-extract-plugin
module.exports = {"PortableDesign":"PortableDesign_PortableDesign__5QlHz"};